// extracted by mini-css-extract-plugin
export default {"legendIndicator":"kka-z","legendNew":"lka-z"};